import { render, staticRenderFns } from "./GameDisplay.vue?vue&type=template&id=ed25676c&"
import script from "./GameDisplay.vue?vue&type=script&lang=js&"
export * from "./GameDisplay.vue?vue&type=script&lang=js&"
import style0 from "./GameDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GameDisplay.vue"
export default component.exports